import React from 'react'
import { useQuery } from 'react-query'
import MetricCard from '../../../../common/components/atom/MetricCard/MetricCard'
import { PowerFactorIcon } from '../../../../common/components/atom/MetricCard/icons'
import { MomiChartSpec } from '../../liveEnergyDashboardConfig'
import { getMomiTelemetryLastMeasurement } from '../../service/momiTelemetryAPI'
import { formatMetricValue, formatMetricDate, lastPoint } from '../../../../common/utils/metricFormat'
import styles from './MomiLastValuesMetrics.module.scss'

interface Props {
  momiUuid: string
  charts: MomiChartSpec[]
}

function MomiMetricCard({
  momiUuid,
  spec,
}: {
  momiUuid: string
  spec: MomiChartSpec
}) {
  const query = useQuery({
    queryKey: ['momi-telemetry-last', momiUuid, spec.measurement],
    queryFn: () => getMomiTelemetryLastMeasurement(momiUuid, spec.measurement),
    enabled: Boolean(momiUuid && spec.measurement),
  })
  const point = lastPoint(query.data)
  const rawValue = point?.Value
  const scaledValue =
    typeof rawValue === 'number' && spec.scale != null
      ? rawValue * spec.scale
      : rawValue

  return (
    <MetricCard
      title={spec.title}
      value={query.isLoading ? '...' : formatMetricValue(scaledValue, 2)}
      unit={spec.unit}
      icon={<PowerFactorIcon />}
      status="ok"
      showPercentage={false}
      showIcon={false}
      tooltip={
        query.isLoading
          ? undefined
          : `Capturé le: ${formatMetricDate(point?.Time)}`
      }
    />
  )
}

export default function MomiLastValuesMetrics({ momiUuid, charts }: Props) {
  // For multi-line specs, show only the first measurement (total) to avoid clutter
  const specs = charts.filter((spec) => !spec.multiLine || spec.multiLine.length === 0)

  if (specs.length === 0) return null

  return (
    <div className={styles.lastValuesContainer}>
      <div className={styles.metricsGrid}>
        {specs.map((spec) => (
          <MomiMetricCard
            key={spec.measurement}
            momiUuid={momiUuid}
            spec={spec}
          />
        ))}
      </div>
    </div>
  )
}
